import Excel from 'exceljs/dist/exceljs.min'
import { saveAs } from 'file-saver'
import {
  getPercentage,
  leadingZero,
  thousand,
  capitalize,
  dateFormatTimezone
} from '@/libs/utils'
import store from '@/store'
import { cloneDeep } from './utils'

class ExcelExport {
  constructor () {
    this.now = new Date()
    this.workbook = new Excel.Workbook()
    this.workbook.creator = 'Beusable'
    this.workbook.created = this.now
    this.workbook.properties.date1904 = true
  }

  setReportInfo (applyData, infoData, reportData, referer, metric, hourData, freqPv, freqTotalPv, freqOption) {
    return new Promise((resolve, reject) => {
      let sheet = this.workbook.addWorksheet('info')
      sheet.views = [{ showGridLines: false, showRuler: false }]

      let columns = [
        { header: '', key: 'blank', width: 3, height: 25 },
        { header: '', key: 'title', width: 22.5, height: 25 },
        { header: '', key: 'value', width: 50, height: 25 }
      ]
      sheet.columns = columns

      let devicePv = infoData.device[reportData.device]
        ? infoData.device[reportData.device].pv
        : 0
      let refererPv = devicePv
      if (referer && referer !== 'all') {
        const refererData = infoData.device[reportData.device].refer
        if (refererData) {
          const item = refererData.find(item => item.refer === referer)
          if (item) {
            refererPv = item.pv
          }
        }
      } else {
        referer = 'All'
      }
      let visitPv = devicePv
      if (reportData.eventSource !== 'all') {
        visitPv = infoData.device[reportData.device][reportData.eventSource + 'Pv']
      }

      let hourPeriod

      if (hourData) {
        if (hourData.toString().length === 1) {
          hourPeriod = store.state.reportPeriod.start + ' 0' + hourData + ':00 ~ ' + ' 0' + hourData + ':59' +
            ' (' + thousand(infoData.pv) + ' PV)'
        } else {
          hourPeriod = store.state.reportPeriod.start + ' ' + hourData + ':00 ~ ' + hourData + ':59' +
            ' (' + thousand(infoData.pv) + ' PV)'
        }
      } else {
        hourPeriod = store.state.reportPeriod.start + ' ~ ' + store.state.reportPeriod.end +
          ' (' + thousand(infoData.pv) + ' PV)'
      }

      let freqData = ''
      let over = '51+'

      if (freqTotalPv) {
        metric.pv = freqTotalPv
      }
      if (freqPv && freqPv.length !== 0) {
        freqPv.sort((a, b) => {
          if (a === -1) return 1
          if (b === -1) return -1
          return a - b
        })

        const start = freqPv[0]
        const end = freqPv[freqPv.length - 1] === -1 ? over : freqPv[freqPv.length - 1]

        const option = freqOption === 'session' ? freqOption.charAt(0).toUpperCase() + freqOption.slice(1) : freqOption.toUpperCase()

        freqData = `[${option}] Visits (${start === end ? start : `${start}-${end}`})`
      }

      let data = [
        { title: 'Download Info', value: '' },
        {
          title: 'Export Date and Time',
          value: dateFormatTimezone(new Date(), applyData.timezoneName, 'YYYY-MM-DD HH:mm:ss')
        },
        {
          title: 'Timezone',
          value: applyData.timezoneName
        },
        { blank: '' },
        { title: 'URL Info', value: '' },
        {
          title: 'Report Link',
          value: window.location.href
        },
        {
          title: 'Domain',
          value: applyData.hostname
        },
        {
          title: 'Group',
          value: applyData.category
        },
        {
          title: 'Match Type',
          value: capitalize(applyData.matchType)
        },
        {
          title: 'URL',
          value: applyData.url
        },
        { blank: '' },
        { title: 'Report Info', value: '' },
        {
          title: 'PV',
          value: thousand(metric.pv)
        },
        {
          title: 'Period',
          value: hourPeriod
        },
        {
          title: 'Device',
          value: capitalize(reportData.device) +
            ' (' + getPercentage(devicePv, infoData.pv).toFixed(1) + '%)'
        },
        {
          title: 'Referrer',
          value: referer +
            ' (' + getPercentage(refererPv, devicePv).toFixed(1) + '%)'
        },
        {
          title: 'User Type',
          value: capitalize(reportData.eventSource) +
            ' (' + getPercentage(visitPv, devicePv).toFixed(1) + '%)'
        }
      ]
      if (freqPv && freqPv.length !== 0) {
        data.push({
          title: 'Frequency',
          value: freqData
        })
      }
      sheet.addRows(data)

      let styles = {
        header: {
          font: {
            size: 16,
            bold: true,
            color: { argb: 'FFEC0047' }
          },
          alignment: {
            vertical: 'middle',
            horizontal: 'left'
          },
          border: {
            left: {
              style: 'thick',
              color: { argb: 'FFEC0047' }
            }
          }
        },
        title: {
          font: {
            size: 10,
            color: { argb: 'FFEC0047' }
          },
          alignment: {
            vertical: 'middle',
            horizontal: 'left'
          },
          border: {
            left: {
              style: 'thick',
              color: { argb: 'FFEC0047' }
            }
          }
        },
        item: {
          font: {
            size: 10,
            color: { argb: 'FF9FA1A5' }
          },
          alignment: {
            vertical: 'middle',
            horizontal: 'left'
          }
        }
      }
      let headerRows = [2, 6, 13]
      let titleRows = [3, 4, 7, 8, 9, 10, 11, 14, 15, 16, 17, 18]
      if (freqPv && freqPv.length !== 0) {
        titleRows.push(19)
      }
      let titleColumn = sheet.getColumn('B')
      titleColumn.eachCell({ includeEmpty: true }, function (cell, rowNumber) {
        if (headerRows.indexOf(rowNumber) !== -1) {
          cell.border = styles.header.border
          cell.font = styles.header.font
          cell.alignment = styles.header.alignment
        } else if (titleRows.indexOf(rowNumber) !== -1) {
          cell.border = styles.title.border
          cell.font = styles.title.font
          cell.alignment = styles.header.alignment
        }
      })

      let itemColumn = sheet.getColumn('C')
      itemColumn.eachCell({ includeEmpty: true }, function (cell, rowNumber) {
        cell.font = styles.item.font
        cell.alignment = styles.item.alignment
      })

      resolve()
    })
  }

  getDetailImageByImage (data, imageUrl, book, sheet) {
    return new Promise((resolve, reject) => {
      const originalImage = new Image()
      originalImage.crossOrigin = 'Anonymous'

      originalImage.onload = async () => {
        for (let i in data) {
          data[i].rank = parseInt(i) + 1
          let selectorTree = data[i].selector.split(' > ')
          let lastSelector = selectorTree[selectorTree.length - 1]
          if (lastSelector.indexOf('svg:') > -1 ||
            lastSelector.indexOf('svg#') > -1
          ) {
            lastSelector = lastSelector.replace('svg:', 'SVG:').replace('svg#', 'SVG#')
          }
          if (lastSelector.indexOf('path:') > -1 ||
            lastSelector.indexOf('path#') > -1
          ) {
            lastSelector = lastSelector.replace('path:', 'PATH:').replace('path#', 'PATH#')
          }
          data[i].tagName = lastSelector.match(/[A-Z]+/)[0]
          data[i].img = ' '

          let maxSize = 400

          const canvas = document.createElement('canvas')
          const ctx = canvas.getContext('2d')
          canvas.width = maxSize
          canvas.height = maxSize
          ctx.fillStyle = '#fff'
          ctx.fillRect(0, 0, maxSize, maxSize)

          let left = data[i].left
          let top = data[i].top
          let width = data[i].width
          let height = data[i].height

          let rate = 1

          let dLeft = 0
          let dTop = 0

          if (width > height) {
            rate = maxSize / width
            dTop = (maxSize - (height * rate)) / 2
          } else {
            rate = maxSize / height
            dLeft = (maxSize - (width * rate)) / 2
          }
          await ctx.drawImage(originalImage,
            left, top,
            width, height,
            dLeft, dTop, width * rate, height * rate
          )

          const tempImage = canvas.toDataURL('image/jpeg', 1.0)

          let thumbnail = book.addImage({
            base64: tempImage,
            extension: 'jpeg'
          })

          await sheet.addImage(thumbnail, `C${parseInt(i) + 2}:C${parseInt(i) + 2}`)

          canvas.remove()
        }
        resolve({ data, book, sheet })
      }

      originalImage.src = imageUrl // imageUrl.split('?')[0]
    })
  }

  setReportData (type, reportData, excelData, imageUrl = null, option = {}) {
    return new Promise(async (resolve, reject) => {
      let book = this.workbook
      let sheet = book.addWorksheet(type)
      sheet.views = [{ showGridLines: false, showRuler: false }]

      let columns = []
      switch (type) {
        case 'click':
          switch (reportData.device) {
            case 'desktop':
              columns = [
                { header: '', key: 'blank', width: 3 },
                { header: 'Rank', key: 'rank', width: 6.5 },
                { header: 'Thumbnail', key: 'img', width: 10 },
                { header: 'Element (CSS Selector)', key: 'selector', width: 30 },
                { header: 'Tag Name', key: 'tagName', width: 15 },
                { header: 'Position_X(px)', key: 'left', width: 15 },
                { header: 'Position_Y(px)', key: 'top', width: 15 },
                { header: 'Size_Width(px)', key: 'width', width: 12 },
                { header: 'Size_Height(px)', key: 'height', width: 12 },
                { header: 'Click Count', key: 'clickCount', width: 12 },
                { header: 'Click Rate(%)', key: 'clickRate', width: 12 },
                { header: 'Unique Click', key: 'pvCount', width: 12 },
                { header: 'Click PV Rate(%)', key: 'clickPvRate', width: 12 },
                { header: 'Scroll to Click(%)', key: 'scrollPvToPv', width: 12 },
                { header: 'Hover to Click(%)', key: 'hoverClickRate', width: 12 },
                { header: 'Hover to Click Time(s)', key: 'hoverClickTime', width: 12 },
                { header: 'Hover Count', key: 'hoverCount', width: 12 }
              ]
              break
            default:
              columns = [
                { header: '', key: 'blank', width: 3 },
                { header: 'Rank', key: 'rank', width: 6.5 },
                { header: 'Thumbnail', key: 'img', width: 10 },
                { header: 'Element (CSS Selector)', key: 'selector', width: 30 },
                { header: 'Tag Name', key: 'tagName', width: 15 },
                { header: 'Position_X(px)', key: 'left', width: 15 },
                { header: 'Position_Y(px)', key: 'top', width: 15 },
                { header: 'Size_Width(px)', key: 'width', width: 12 },
                { header: 'Size_Height(px)', key: 'height', width: 12 },
                { header: 'Click Count', key: 'clickCount', width: 12 },
                { header: 'Click Rate(%)', key: 'clickRate', width: 12 },
                { header: 'Unique Click', key: 'pvCount', width: 12 },
                { header: 'Click PV Rate(%)', key: 'clickPvRate', width: 12 },
                { header: 'Scroll to Click(%)', key: 'scrollPvToPv', width: 12 }
              ]
          }
          break
        case 'tap':
          columns = [
            { header: '', key: 'blank', width: 3 },
            { header: 'Rank', key: 'rank', width: 6.5 },
            { header: 'Thumbnail', key: 'img', width: 10 },
            { header: 'Element (CSS Selector)', key: 'selector', width: 30 },
            { header: 'Tag Name', key: 'tagName', width: 15 },
            { header: 'Position_X(px)', key: 'left', width: 15 },
            { header: 'Position_Y(px)', key: 'top', width: 15 },
            { header: 'Size_Width(px)', key: 'width', width: 12 },
            { header: 'Size_Height(px)', key: 'height', width: 12 },
            { header: 'Tap Count', key: 'tapCount', width: 12 },
            { header: 'Tap Rate(%)', key: 'tapRate', width: 12 },
            { header: 'Unique Tap', key: 'pvCount', width: 12 },
            { header: 'Tap PV Rate(%)', key: 'tapPvRate', width: 12 },
            { header: 'Scroll To Tap(%)', key: 'scrollPvToPv', width: 12 },
            { header: 'Dbl. Tap Rate(%)', key: 'doubleTapRate', width: 12 }
          ]
          break
        case 'move':
          columns = [
            { header: '', key: 'blank', width: 3 },
            { header: 'Rank', key: 'rank', width: 6.5 },
            { header: 'Thumbnail', key: 'img', width: 10 },
            { header: 'Element (CSS Selector)', key: 'selector', width: 30 },
            { header: 'Tag Name', key: 'tagName', width: 15 },
            { header: 'Position_X(px)', key: 'left', width: 15 },
            { header: 'Position_Y(px)', key: 'top', width: 15 },
            { header: 'Size_Width(px)', key: 'width', width: 12 },
            { header: 'Size_Height(px)', key: 'height', width: 12 },
            { header: 'Hover Count', key: 'hoverCount', width: 12 },
            { header: 'Click Rate(%)', key: 'clickRate', width: 12 },
            { header: 'Unique Click', key: 'pvCount', width: 12 },
            { header: 'Click PV Rate(%)', key: 'clickPvRate', width: 12 },
            { header: 'Scroll To Click(%)', key: 'scrollPvToPv', width: 12 },
            { header: 'Hover to Click(%)', key: 'hoverClickRate', width: 12 },
            { header: 'Hover to Click Time(s)', key: 'hoverClickTime', width: 12 },
            { header: 'Click Count', key: 'clickCount', width: 12 }
          ]
          break
        case 'zoom':
          columns = [
            { header: '', key: 'blank', width: 3 },
            { header: 'Rank', key: 'rank', width: 6.5 },
            { header: 'Thumbnail', key: 'img', width: 10 },
            { header: 'Element (CSS Selector)', key: 'selector', width: 30 },
            { header: 'Tag Name', key: 'tagName', width: 15 },
            { header: 'Position_X(px)', key: 'left', width: 15 },
            { header: 'Position_Y(px)', key: 'top', width: 15 },
            { header: 'Size_Width(px)', key: 'width', width: 12 },
            { header: 'Size_Height(px)', key: 'height', width: 12 },
            {
              header: (option.heatmapType === 'in' ? 'Zoom In Count' : 'Zoom Out Count'),
              key: (option.heatmapType === 'in' ? 'zoominCount' : 'zoomoutCount'),
              width: 12
            },
            { header: 'Zoom In Rate(%)', key: 'zoominRate', width: 12 },
            { header: 'Zoom Out Rate(%)', key: 'zoomoutRate', width: 12 }
          ]
          break
        case 'scroll':
          columns = [
            { header: '', key: 'blank', width: 3 },
            { header: 'Percentage From\nTop', key: 'topPercentage', width: 12 },
            { header: 'PX From Top', key: 'dy', width: 12 },
            { header: 'Reach PV Rate(%)', key: 'percentage', width: 12 },
            { header: 'Avg. Focus Duration(sec)', key: 'attention', width: 12 },
            { header: 'Note', key: 'note', width: 12 }
          ]
          break
        case 'swipe':
          if (option.heatmapType === 'vert') {
            columns = [
              { header: '', key: 'blank', width: 3 },
              { header: 'PX From Top', key: 'dy', width: 12 },
              { header: 'Swipe Up', key: 'left', width: 12 },
              { header: 'Swipe Down', key: 'right', width: 12 }
            ]
          } else if (option.heatmapType === 'horiz') {
            columns = [
              { header: '', key: 'blank', width: 3 },
              { header: 'PX From Top', key: 'dy', width: 12 },
              { header: 'Swipe Left', key: 'left', width: 12 },
              { header: 'Swipe Right', key: 'right', width: 12 }
            ]
          }
          break
      }
      sheet.columns = columns

      let data = []

      if (['click', 'move', 'tap', 'zoom'].includes(type)) {
        excelData.forEach(item => {
          let d = cloneDeep(item)
          if (isNaN(d.scrollPvToPv)) {
            d.scrollPvToPv = 'Infinity'
          }
          data.push(d)
        })

        if (data.length) {
          try {
            const imageData = await this.getDetailImageByImage(data, imageUrl, book, sheet)
            data = imageData.data
            sheet = imageData.sheet
            resolve()
          } catch (e) {
            reject(e)
          }
        } else {
          resolve()
        }
      } else if (type === 'swipe') {
        const heatmapType = option.heatmapType === 'vert' ? 0 : 1
        for (let i in excelData.data[heatmapType].left) {
          let d = {
            dy: i * 100 + 100,
            left: excelData.data[heatmapType].left[i] || 0,
            right: excelData.data[heatmapType].right[i] || 0
          }
          data.push(d)
        }
      } else if (type === 'scroll') {
        let height = Math.round(excelData.fold.aboveSize + excelData.fold.belowSize)
        let avgFold = Math.floor(excelData.fold.aboveSize / height * 100)
        let avgFoldDy = Math.round(excelData.fold.aboveSize)
        for (let i in excelData.attentionItems) {
          if (excelData.attentionItems[i].topPercentage % 5 === 0) {
            let dy = height / 100 * excelData.attentionItems[i].topPercentage
            let d = {
              topPercentage: excelData.attentionItems[i].topPercentage + '%',
              dy: Math.round(dy),
              percentage: excelData.attentionItems[i].percentage,
              attention: excelData.attentionItems[i].attention
            }
            if (excelData.attentionItems[i].topPercentage === avgFold) {
              if (dy === avgFoldDy) {
                d['note'] = 'Average Fold'
                data.push(d)
              } else {
                let avg = {
                  topPercentage: excelData.attentionItems[i].topPercentage + '%',
                  dy: avgFoldDy,
                  percentage: '',
                  attention: '',
                  note: 'Average Fold'
                }
                if (dy < avgFoldDy) {
                  data.push(d)
                  data.push(avg)
                } else {
                  data.push(avg)
                  data.push(d)
                }
              }
            } else {
              data.push(d)
            }
          } else if (excelData.attentionItems[i].topPercentage === avgFold) {
            let d = {
              topPercentage: excelData.attentionItems[i].topPercentage + '%',
              dy: avgFoldDy,
              percentage: '',
              attention: '',
              note: 'Average Fold'
            }
            data.push(d)
          }
        }
      }
      data.push({ blank: '' })
      sheet.addRows(data)

      let styles = {
        header: {
          font: {
            size: 10,
            color: { argb: 'FFE7E6E6' }
          },
          alignment: {
            vertical: 'middle',
            horizontal: 'center'
          },
          border: {
            top: { style: 'thin', color: { argb: 'FF2F384B' } },
            left: { style: 'thin', color: { argb: 'FF2F384B' } },
            bottom: { style: 'thin', color: { argb: 'FF2F384B' } },
            right: { style: 'thin', color: { argb: 'FF2F384B' } }
          },
          fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FF2F384B' },
            bcColor: { argb: 'FFFFFFFF' }
          }
        },
        footer: {
          border: {
            top: { style: 'thin', color: { argb: 'FF2F384B' } },
            left: { style: 'thin', color: { argb: 'FF2F384B' } },
            bottom: { style: 'thin', color: { argb: 'FF2F384B' } },
            right: { style: 'thin', color: { argb: 'FF2F384B' } }
          },
          fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FF2F384B' },
            bcColor: { argb: 'FFFFFFFF' }
          }
        },
        item: {
          border: {
            top: { style: 'thin', color: { argb: 'FFE7E6E6' } },
            left: { style: 'thin', color: { argb: 'FFE7E6E6' } },
            bottom: { style: 'thin', color: { argb: 'FFE7E6E6' } },
            right: { style: 'thin', color: { argb: 'FFE7E6E6' } }
          },
          font: {
            size: 10,
            color: { argb: 'FF2F384B' }
          },
          fontRed: {
            size: 10,
            color: { argb: 'FFFF6160' }
          },
          fontBlue: {
            size: 10,
            color: { argb: 'FF8EA9DB' }
          },
          alignment: {
            vertical: 'middle',
            horizontal: 'center'
          }
        }
      }

      sheet.views = [
        { state: 'frozen', ySplit: 1 }
      ]
      sheet.eachRow(function (row, rowNumber) {
        if (rowNumber === 1) {
          row.height = 40
          row.border = styles.header.border
          row.font = styles.header.font
          row.alignment = styles.header.alignment
          row.fill = styles.header.fill
        } else if (rowNumber === sheet.rowCount) {
          row.border = styles.footer.border
          row.fill = styles.footer.fill
        } else {
          if (['scroll', 'swipe'].includes(type)) {
            row.height = 17
          } else {
            row.height = 60
          }
          row.border = styles.item.border
          row.font = styles.item.font
          row.alignment = styles.item.alignment
        }
      })

      sheet.getColumn('A').eachCell({ includeEmpty: true }, function (cell) {
        cell.fill = null
        cell.border = null
      })

      if (['click', 'move', 'tap', 'zoom'].includes(type)) {
        sheet.getColumn('D').eachCell({ includeEmpty: true }, function (cell) {
          cell.font = styles.item.fontBlue
        })
        sheet.getColumn('F').eachCell({ includeEmpty: true }, function (cell) {
          if (option.highlight === 'F') cell.font = styles.item.fontRed
          cell.numFmt = '#,##0'
        })
        sheet.getColumn('G').eachCell({ includeEmpty: true }, function (cell) {
          if (option.highlight === 'G') cell.font = styles.item.fontRed
          cell.numFmt = '#,##0'
        })
        sheet.getColumn('H').eachCell({ includeEmpty: true }, function (cell) {
          if (option.highlight === 'H') cell.font = styles.item.fontRed
          cell.numFmt = '#,##0'
        })
        sheet.getColumn('I').eachCell({ includeEmpty: true }, function (cell) {
          if (option.highlight === 'I') cell.font = styles.item.fontRed
          cell.numFmt = '#,##0'
        })
        sheet.getColumn('J').eachCell({ includeEmpty: true }, function (cell) {
          if (option.highlight === 'J') cell.font = styles.item.fontRed
          cell.numFmt = '#,##0'
        })
        sheet.getColumn('K').eachCell({ includeEmpty: true }, function (cell) {
          if (option.highlight === 'K') cell.font = styles.item.fontRed
          cell.numFmt = '0.0'
        })
        sheet.getColumn('L').eachCell({ includeEmpty: true }, function (cell) {
          if (option.highlight === 'L') cell.font = styles.item.fontRed
          cell.numFmt = '#,##0'
        })
        sheet.getColumn('M').eachCell({ includeEmpty: true }, function (cell) {
          if (option.highlight === 'M') cell.font = styles.item.fontRed
          cell.numFmt = '0.0'
        })
        sheet.getColumn('N').eachCell({ includeEmpty: true }, function (cell) {
          if (option.highlight === 'N') cell.font = styles.item.fontRed
          cell.numFmt = '0.0'
        })
        sheet.getColumn('O').eachCell({ includeEmpty: true }, function (cell) {
          if (option.highlight === 'O') cell.font = styles.item.fontRed
          cell.numFmt = '0.0'
        })
        sheet.getColumn('P').eachCell({ includeEmpty: true }, function (cell) {
          if (option.highlight === 'P') cell.font = styles.item.fontRed
          cell.numFmt = '0.0'
        })
        sheet.getColumn('Q').eachCell({ includeEmpty: true }, function (cell) {
          if (option.highlight === 'Q') cell.font = styles.item.fontRed
          cell.numFmt = '#,##0'
        })
      } else if (type === 'swipe') {
        sheet.getColumn('B').eachCell({ includeEmpty: true }, function (cell) {
          cell.numFmt = '#,##0'
        })
        sheet.getColumn('C').eachCell({ includeEmpty: true }, function (cell) {
          cell.numFmt = '#,##0'
        })
        sheet.getColumn('D').eachCell({ includeEmpty: true }, function (cell) {
          cell.numFmt = '#,##0'
        })
        resolve()
      } else if (type === 'scroll') {
        sheet.getColumn('C').eachCell({ includeEmpty: true }, function (cell) {
          if (option.highlight === 'C') cell.font = styles.item.fontRed
          cell.numFmt = '#,##0'
        })
        sheet.getColumn('D').eachCell({ includeEmpty: true }, function (cell) {
          if (option.highlight === 'D') cell.font = styles.item.fontRed
          cell.numFmt = '0.0'
        })
        sheet.getColumn('E').eachCell({ includeEmpty: true }, function (cell) {
          if (option.highlight === 'E') cell.font = styles.item.fontRed
          cell.numFmt = '0.0'
        })
        sheet.getColumn('F').eachCell({ includeEmpty: true }, function (cell) {
          if (option.highlight === 'F') cell.font = styles.item.fontRed
        })
        resolve()
      }
    })
  }

  download (fileName) {
    return new Promise((resolve, reject) => {
      fileName +=
        '_' + this.now.getFullYear() + '-' + leadingZero(this.now.getMonth() + 1) + '-' + leadingZero(this.now.getDate()) +
        'T' + leadingZero(this.now.getHours()) + '-' + leadingZero(this.now.getMinutes()) + '-' + leadingZero(this.now.getSeconds()) +
        '.xlsx'
      this.workbook.xlsx.writeBuffer()
        .then(function (data) {
          let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          saveAs(blob, fileName)
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}

export default ExcelExport
